export default __webpack_public_path__ + "static/media/btc_light.75f76f91.svg";